import { Router } from "@frui.ts/screens/dist";
import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { Modules } from "../../config";
import LocalizationService from "../../services/localizationService";
import SecurityService from "../../services/securityService";
import EnforcementUsersViewModel from "./enforcementUsers/enforcementUsersViewModel";
import GatewaysViewModel from "./gateways/gatewaysViewModel";
import EnforcementTabletsViewModel from "./enforcementTablets/enforcementTabletsViewModel";
import ModuleViewModel from "../moduleViewModel";
import EnforcementReportsViewModel from "./reporting/enforcementReportsViewModel";
import LustrationReportsViewModel from "./lustrationReports/lustrationReportsViewModel";

@Router.registerRoute({
  route: Modules.enforcement,
  name: Router.Self,
  children: [GatewaysViewModel, EnforcementUsersViewModel, EnforcementTabletsViewModel, EnforcementReportsViewModel],
})
export default class EnforcementViewModel extends ModuleViewModel<ScreenBase> {
  protected readonly module = Modules.enforcement;

  constructor(
    protected localizationService: LocalizationService,
    private gatewaysViewModel: GatewaysViewModel,
    private enforcementUsersViewModel: EnforcementUsersViewModel,
    private enforcementTabletsViewModel: EnforcementTabletsViewModel,
    private reportingViewModel: EnforcementReportsViewModel,
    private lustrationReportsViewModel: LustrationReportsViewModel,
    private securityService: SecurityService
  ) {
    super();
    this.navigationName = this.module;

    if (this.securityService.allowTo("enforcement")) {
      this.children.push(this.gatewaysViewModel, this.enforcementTabletsViewModel, this.enforcementUsersViewModel);
    }
    if (this.securityService.allowTo("enforcement.reports")) {
      this.children.push(this.reportingViewModel);
    }

    if (this.securityService.allowTo("enforcement.lustration")) {
      this.children.push(this.lustrationReportsViewModel);
    }
  }
}
